export const rules = {
	// Card titles
	"rules.card.rules.title": "Regole",
	"rules.card.pointsAllocation.title": "Assegnazione punti",
	"rules.card.rulesContinued.title": "Regole (continua)",
	"rules.card.weeklyPrizes.title": "Struttura premi settimanali",

	// Main rules content
	"rules.intro":
		'Tutti i termini in maiuscolo utilizzati in queste regole (le <strong>"Regole"</strong>) porteranno la definizione ad essi attribuita nei termini e condizioni (i <strong>"Termini e Condizioni"</strong>).',

	"rules.temporary_notice":
		"Si prega di notare che i vincitori dei premi nel periodo dal 19 dicembre 2025 al 2 gennaio 2026 riceveranno i loro premi entro 7 (sette) giorni a partire dal 6 gennaio 2026",

	"rules.rule1":
		"I partecipanti possono guadagnare punti prevedendo correttamente il punteggio di ciascuna delle cinque (5) partite ogni settimana/round (a seconda del caso), rilevanti per la competizione sportiva a cui il gioco Betway Scores BW ScorePredict si riferisce, ad esempio <em>Premier League inglese</em>, ecc. La competizione Betway Scores BW Score Predict inizierà l'11 marzo 2025 e si concluderà alla fine della stagione calcistica 2025/2026.",

	"rules.rule2.main":
		"I partecipanti possono guadagnare punti bonus aggiuntivi prevedendo correttamente quanto segue in ciascuna delle cinque (5) partite:",
	"rules.rule2.a": "Punteggio finale corretto",
	"rules.rule2.b": "Vincitore corretto",
	"rules.rule2.c": "Gol in casa corretti",
	"rules.rule2.d": "Gol in trasferta corretti",
	"rules.rule2.e": "Differenza reti corretta",

	"rules.rule3": "Ogni settimana/round correla con i round di quella competizione sportiva.",

	"rules.rule4": "I punti sono assegnati come segue per ciascuna delle seguenti previsioni corrette del Partecipante ogni settimana/round:",

	// Points allocation
	"rules.points.correctScore": "Punteggio finale corretto",
	"rules.points.correctScoreValue": "50",
	"rules.points.correctWinner": "Vincitore corretto",
	"rules.points.correctWinnerValue": "5",
	"rules.points.homeGoals": "Gol in casa corretti",
	"rules.points.homeGoalsValue": "5",
	"rules.points.awayGoals": "Gol in trasferta corretti",
	"rules.points.awayGoalsValue": "5",
	"rules.points.goalDifference": "Differenza reti corretta",
	"rules.points.goalDifferenceValue": "5",

	// Continued rules
	"rules.rule5":
		"I partecipanti possono apportare modifiche alle loro previsioni in qualsiasi momento, fino a 15 minuti prima del calcio d'inizio di ciascuna delle partite della settimana/round pertinente.",

	"rules.rule6":
		"Tutti gli utenti registrati di Betway Scores e/o BW Scores sono idonei a giocare a Betway Scores BW ScorePredict, tuttavia solo i partecipanti con un account Betway verificato, al momento in cui i premi devono essere assegnati, sono idonei a vincere premi. I cambiamenti nei risultati della partita secondo il punto 2. sopra che si verificano dopo l'assegnazione dei premi (ad esempio annullamento del risultato) non saranno considerati retrospettivamente.",

	"rules.rule7":
		"Il partecipante qualificato ed idoneo che finisce la stagione al primo posto e ha un Account Betway sarà il vincitore del Gran Premio per la stagione e vincerà un viaggio per due (2) persone per vedere l'Arsenal giocare a Londra, inclusi voli (se necessario), alloggio (se necessario) e £500 di spese.",

	"rules.rule8":
		"Se il vincitore del Gran Premio per la stagione non può viaggiare a causa di non avere un passaporto valido e/o visto e/o qualsiasi altra limitazione, riceverà un premio di €5.000 di saldo in contanti, o l'equivalente approssimativo in valuta locale alla data di inizio della competizione (essendo £4.500, R100.000 o GH₵ 60.000), nel loro Account Betway al completamento della competizione.",

	"rules.rule9":
		"Il vincitore del Gran Premio della stagione può scegliere di non prendere l'esperienza e piuttosto accettare un premio di €5.000 di saldo in contanti, o l'equivalente approssimativo in valuta locale alla data di inizio della competizione (essendo £4.500, R100.000 o GH₵ 60.000), nel loro Account Betway.",

	"rules.rule10":
		'I premi settimanali saranno assegnati ai "Top 10" performer ogni settimana/round che hanno un Account di Scommesse Betway valido. Se un performer Top 10 non ha un Account di Scommesse Betway, non riceverà un Premio Settimanale.',

	"rules.rule11":
		"I posti settimanali dall'1 al 10 vinceranno i seguenti importi di saldo in contanti, a seconda della loro regione, nel loro Account Betway.",

	"rules.rule12":
		"I premi settimanali saranno assegnati entro 7 (sette) giorni dalla finalizzazione dei risultati di quella settimana e il Gran Premio sarà assegnato entro 7 (sette) giorni dalla conclusione della competizione Betway Scores BW Score Predict.",

	"rules.rule13":
		"In caso di pareggio per i premi settimanali, il saldo in contanti per quella posizione (e le posizioni rilevanti sotto di essa che sono impattate dal pareggio) sarà diviso equamente tra i partecipanti in pareggio.",

	"rules.rule14":
		"In caso di pareggio per il Gran Premio, sarà utilizzato un meccanismo randomizzatore per selezionare solo uno dei partecipanti in pareggio come vincitore del Gran Premio.",

	// Weekly prize table data
	"rules.weeklyPrizes.position1.eur": "€150",
	"rules.weeklyPrizes.position1.gbp": "£150",
	"rules.weeklyPrizes.position1.zar": "R3000",
	"rules.weeklyPrizes.position1.ghs": "GH₵2000",

	"rules.weeklyPrizes.position2.eur": "€100",
	"rules.weeklyPrizes.position2.gbp": "£100",
	"rules.weeklyPrizes.position2.zar": "R2000",
	"rules.weeklyPrizes.position2.ghs": "GH₵1250",

	"rules.weeklyPrizes.position3.eur": "€75",
	"rules.weeklyPrizes.position3.gbp": "£75",
	"rules.weeklyPrizes.position3.zar": "R1500",
	"rules.weeklyPrizes.position3.ghs": "GH₵1000",

	"rules.weeklyPrizes.position4.eur": "€50",
	"rules.weeklyPrizes.position4.gbp": "£50",
	"rules.weeklyPrizes.position4.zar": "R1000",
	"rules.weeklyPrizes.position4.ghs": "GH₵600",

	"rules.weeklyPrizes.position5.eur": "€40",
	"rules.weeklyPrizes.position5.gbp": "£40",
	"rules.weeklyPrizes.position5.zar": "R800",
	"rules.weeklyPrizes.position5.ghs": "GH₵500",

	"rules.weeklyPrizes.position6.eur": "€30",
	"rules.weeklyPrizes.position6.gbp": "£30",
	"rules.weeklyPrizes.position6.zar": "R600",
	"rules.weeklyPrizes.position6.ghs": "GH₵400",

	"rules.weeklyPrizes.position7.eur": "€20",
	"rules.weeklyPrizes.position7.gbp": "£20",
	"rules.weeklyPrizes.position7.zar": "R400",
	"rules.weeklyPrizes.position7.ghs": "GH₵250",

	"rules.weeklyPrizes.position8.eur": "€15",
	"rules.weeklyPrizes.position8.gbp": "£15",
	"rules.weeklyPrizes.position8.zar": "R300",
	"rules.weeklyPrizes.position8.ghs": "GH₵200",

	"rules.weeklyPrizes.position9.eur": "€10",
	"rules.weeklyPrizes.position9.gbp": "£10",
	"rules.weeklyPrizes.position9.zar": "R200",
	"rules.weeklyPrizes.position9.ghs": "GH₵100",

	"rules.weeklyPrizes.position10.eur": "€10",
	"rules.weeklyPrizes.position10.gbp": "£10",
	"rules.weeklyPrizes.position10.zar": "R200",
	"rules.weeklyPrizes.position10.ghs": "GH₵100",

	// Table headers
	"rules.weeklyPrizes.header.position": "# Per round",
	"rules.weeklyPrizes.header.eur": "EUR",
	"rules.weeklyPrizes.header.gbp": "GBP",
	"rules.weeklyPrizes.header.zar": "ZAR",
	"rules.weeklyPrizes.header.ghs": "GHS",
};
